import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Fitness.css';

const Fitness = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Fitness Services | Digi Network" 
                description="Learn more about our Fitness services to grow your business online with Digi Network." 
                canonical="/industries/fitness/fitness" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Fitness & Wellness Industry</div>
                        <h1>Digital Marketing for Fitness & Wellness</h1>
                        <p>Attract members, build community, and grow your fitness business with digital marketing strategies that inspire action and drive sign-ups. We understand the unique challenges fitness and wellness businesses face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Fitness Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Fitness & Wellness Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for fitness businesses</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Fitness SEO</h3>
                            <p>Rank for local gym searches, fitness keywords, and attract members in your area. Our fitness SEO strategies help gyms and studios dominate local search results and attract qualified members.</p>
                            <ul>
                                <li>Local SEO for gyms & studios</li>
                                <li>Fitness keyword optimization</li>
                                <li>Class schedule optimization</li>
                                <li>Google My Business for fitness</li>
                                <li>Fitness directory listings</li>
                                <li>Review management</li>
                            </ul>
                            <Link to="/industries/fitness/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Fitness Paid Ads</h3>
                            <p>Drive sign-ups with compelling advertising campaigns that showcase your fitness offerings. Our targeted ad campaigns reach people actively looking to start or improve their fitness journey.</p>
                            <ul>
                                <li>Facebook & Instagram fitness ads</li>
                                <li>Google Ads for gyms</li>
                                <li>Video advertising campaigns</li>
                                <li>Promotion & offer campaigns</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/fitness/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Fitness Website Design</h3>
                            <p>Engaging fitness websites with class schedules, member portals, and online booking. Our fitness websites are designed to showcase your offerings and make it easy for people to join.</p>
                            <ul>
                                <li>Gym & studio websites</li>
                                <li>Class booking integration</li>
                                <li>Member portal development</li>
                                <li>Virtual class platforms</li>
                                <li>Mobile-responsive design</li>
                                <li>Testimonial sections</li>
                            </ul>
                            <Link to="/industries/fitness/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Fitness Email Marketing</h3>
                            <p>Engage members with workout tips, class updates, and automated retention campaigns. Build lasting relationships with members through strategic email communication that motivates and inspires.</p>
                            <ul>
                                <li>Member engagement campaigns</li>
                                <li>Class reminder emails</li>
                                <li>Wellness content newsletters</li>
                                <li>Retention & win-back campaigns</li>
                                <li>New member onboarding</li>
                                <li>Promotional campaigns</li>
                            </ul>
                            <Link to="/industries/fitness/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Fitness CRM & Automation</h3>
                            <p>Manage members, automate communications, and streamline operations with GoHighLevel. Automate your member management and communication workflows to improve retention and satisfaction.</p>
                            <ul>
                                <li>Member management system</li>
                                <li>Automated welcome sequences</li>
                                <li>Class booking reminders</li>
                                <li>Membership renewal automation</li>
                                <li>Member feedback tracking</li>
                                <li>Retention automation</li>
                            </ul>
                            <Link to="/industries/fitness/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our Fitness Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for fitness businesses</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Business Analysis</h3>
                            <p>We analyze your fitness business, target audience, and competitive landscape to understand your unique positioning. Our team conducts comprehensive audits of your current marketing and member engagement strategies.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Community Building Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on building a strong community around your fitness brand. Every tactic is designed to attract and retain members who are committed to their fitness journey.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from social media to email to paid ads. Our team handles everything from content creation to ad campaign launches.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Member Retention & Growth</h3>
                            <p>We continuously monitor member engagement, analyze feedback, and optimize campaigns for better retention. Regular reporting keeps you informed of your marketing ROI and member acquisition metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Fitness Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Fitness & Wellness Businesses Choose Digi Network</h2>
                    <p className="why-intro">Trusted by fitness professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Community Building</h3>
                            <p>We create campaigns that build community and inspire people to take action on their fitness goals. We understand that fitness is about more than just working out—it's about belonging to a community.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Fitness Industry Expertise</h3>
                            <p>We understand the fitness market and create campaigns that resonate with health-conscious audiences. Our team has extensive experience working with gyms, studios, and wellness centers.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Member Acquisition</h3>
                            <p>We focus on attracting quality members who are committed to their fitness journey. Our strategies target people who are serious about improving their health and wellness.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped fitness businesses increase membership by 250%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your membership numbers.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Fitness Businesses</h2>
                    <p className="section-intro">How our marketing services help you grow your fitness business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Members</h3>
                            <p>Attract more qualified members through targeted marketing campaigns that reach people actively looking to start or improve their fitness journey. Our strategies focus on converting interested prospects into committed members.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Stronger Community</h3>
                            <p>Build a strong community around your fitness brand through social media, email, and content marketing. Engaged members are more likely to stay and refer others to your business.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Member Retention</h3>
                            <p>Improve member retention through automated engagement campaigns and personalized communication. Keep members motivated and coming back for more with strategic retention strategies.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Class Attendance</h3>
                            <p>Boost class attendance with automated reminders and promotional campaigns. Fill your classes and maximize your revenue with strategic attendance marketing.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Revenue</h3>
                            <p>Increase revenue through more memberships, higher attendance, and better retention. Our strategies help you maximize every aspect of your fitness business.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many fitness businesses still rely on basic marketing methods like flyers and word-of-mouth.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Fitness Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Grow Your Fitness Business?</h2>
                    <p>Let's discuss how we can help you attract more members and build your fitness community.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Fitness;
